import { create } from 'zustand';
// utils
import { IAct } from '@newo/api/gateway';

type IActReportDrawerState = {
    act?: IAct;
    selectActToReport: (act?: IAct) => void;
};

const initialState = {
    act: undefined
};

const useActReportDrawerStore = create<IActReportDrawerState>((set) => ({
    ...initialState,
    selectActToReport: (act) => {
        set({ act });
    }
}));

export default useActReportDrawerStore;
